import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "../utils/api";
import PasswordInput from "../components/PasswordInput";

export default function AdminLogin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const { data, status } = await api.login(username, password);
    setLoading(false);
    if (data && data.ok) {
      navigate("/admin", { replace: true });
      return;
    }
    if (status === 429 && data && data.retry_after_minutes) {
      setError(`Zu viele Fehlversuche. Bitte in ca. ${data.retry_after_minutes} Minuten erneut versuchen.`);
    } else {
      setError("Benutzername oder Passwort ist falsch.");
    }
  };

  return (
    <div className="admin-page" data-testid="admin-login-page">
      <div className="admin-card">
        <h1 className="admin-title">Praxis-Login</h1>
        <p className="admin-subtitle">Interner Bereich – bitte anmelden</p>

        <form onSubmit={submit} className="admin-form" data-testid="admin-login-form">
          <label className="admin-label">
            Benutzername
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
              required
              data-testid="admin-username-input"
            />
          </label>

          <label className="admin-label">
            Passwort
            <PasswordInput
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
              data-testid="admin-password-input"
            />
          </label>

          {error && <p className="admin-error" data-testid="admin-login-error">{error}</p>}

          <button type="submit" className="admin-btn admin-btn-primary" disabled={loading} data-testid="admin-login-submit">
            {loading ? "Bitte warten…" : "Anmelden"}
          </button>

          <div className="admin-footer-links">
            <Link to="/admin/forgot" data-testid="admin-forgot-link">Passwort vergessen?</Link>
            <Link to="/" data-testid="admin-back-home">Zurück zur Startseite</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
